import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Pillars from "../components/Pillars";
import Metrics from "../components/Metrics";
import Challenge from "../components/Challenge";
import Solution from "../components/Solution";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      style={{ background: "var(--bg)", color: "var(--text)" }}
    >
      <Nav />
      <main>
        <Hero />
        <Pillars />
        <Metrics />
        <Challenge />
        <Solution />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
